import {DataContentWrapper} from '@hconnect/common/containers'
import {StoppageEvent} from '@hconnect/common/stoppages/types/stoppage.types'
import {DateRange, StoppageDto as Stoppage, TimeZone} from '@hconnect/common/types'
import {CardBox, PaginationOptions} from '@hconnect/uikit/src/lib2'
import {FC, useState} from 'react'

import {StoppageAnalysisList} from '../components'
import {useShiftEventStoppages} from '../hooks/useShiftEventStoppages'

type TimeRange = {
  startDate: string
  endDate: string
}

type StoppageAnalysisListContainerProps = {
  plantId: string
  equipmentId: string
  timezone: TimeZone
  timeRange: DateRange
  onRowClick: (stoppage?: StoppageEvent) => void
  stoppageToPreview?: Stoppage
}

export const StoppageAnalysisListContainer: FC<StoppageAnalysisListContainerProps> = ({
  plantId,
  equipmentId,
  timezone,
  onRowClick,
  stoppageToPreview,
  timeRange
}) => {
  const dateRange: TimeRange = {
    startDate: timeRange.startDate.toJSON(),
    endDate: timeRange.endDate.toJSON()
  }

  const [pageNumber, changePage] = useState<number>(0)
  const [itemsPerPage, setItemsPerPage] = useState<number>(50)

  const {data, isLoading, isError, refetch, isRefetching} = useShiftEventStoppages(
    plantId,
    dateRange,
    pageNumber,
    itemsPerPage,
    equipmentId
  )
  const eventsList = data?.events || []

  const onPaginationChange = (pageNumber: number, itemsPerPage: number) => {
    changePage(pageNumber)
    setItemsPerPage(itemsPerPage)
  }

  const paginationOptions: PaginationOptions = {
    onPaginationChange,
    page: pageNumber,
    rowsPerPage: itemsPerPage,
    totalDataLength: data?.totalItemCount || 0
  }

  return (
    <CardBox>
      <DataContentWrapper
        showLoader={isLoading}
        data={eventsList}
        retryFunction={() => void refetch()}
        isError={isError}
        isRefetching={isRefetching}
        progressSx={{color: 'primary.main'}}
      >
        <StoppageAnalysisList
          data={eventsList}
          timezone={timezone}
          onRowClick={onRowClick}
          stoppageToPreview={stoppageToPreview}
          paginationOptions={paginationOptions}
        />
      </DataContentWrapper>
    </CardBox>
  )
}
